import {CustomScrollbarTrackVisibility} from "./custom-scrollbar-model";

class CustomScrollbarHelper {

    getScrollbarSize_() {
        const outer = document.createElement('div');

        outer.style.width = '100px';
        outer.style.height = '100px';
        outer.style.position = 'absolute';
        outer.style.top = '-9999px';
        outer.style.overflow = 'scroll';
        outer.style.msOverflowStyle = 'scrollbar';
        outer.style.scrollbarWidth = 'none';
        document.body.appendChild(outer);

        const inner = document.createElement('div');
        inner.style.width = '100%';
        inner.style.height = '1000px';

        outer.appendChild(inner);

        const scrollbarSize = outer.offsetWidth - inner.offsetWidth + 1;        // track visibility check scrollWidth/Height > clientWidht/Height needs +1 here

        outer.parentNode.removeChild(outer);
        return scrollbarSize;
    }

    getScrollbarSize()  {
        // if we have a cached value return it
        if(this.scrollbarSize)  return this.scrollbarSize;

        // otherwise initialize cached value and setup a listener to appropriate events to update it
        this.scrollbarSize = this.getScrollbarSize_();

        window.addEventListener('resize', () => {
            this.scrollbarSize = this.getScrollbarSize_();
        });

        return this.scrollbarSize;
    }

    //
    getTrackInnerWidth(ref) {
        if(!ref)    return 0;
        const {paddingLeft, paddingRight} = getComputedStyle(ref);
        return ref.clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
    }

   getTrackInnerHeight(ref) {
        if(!ref)    return 0;
        const {paddingTop, paddingBottom} = getComputedStyle(ref);
        return ref.clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
    }

    //
    getHorizontalThumbWidth(scrollbar, props)  {
        props = props || scrollbar.props;
        return this.getHorizontalThumbWidth2(scrollbar.viewRef, scrollbar.horizontalTrackRef, scrollbar.unitSize * props.thumbSize, scrollbar.unitSize * props.minThumbSize);
    }

    getHorizontalThumbWidth2(viewRef, trackRef, thumbSize, minThumbSize = 32)    {
        if(!viewRef || !trackRef)    return 0;

        const {scrollWidth, clientWidth} = viewRef;
        if(scrollWidth == 0)    return 0;
        const trackWidth = this.getTrackInnerWidth(trackRef);
        const width = Math.ceil(clientWidth / scrollWidth * trackWidth);

        if(trackWidth === width)    return 0;

        if(thumbSize)   return thumbSize;

        return Math.max(width, minThumbSize);
    }

    //
    getVerticalThumbHeight(scrollbar, props)  {
        props = props || scrollbar.props;
        return this.getVerticalThumbHeight2(scrollbar.viewRef, scrollbar.verticalTrackRef, scrollbar.unitSize * props.thumbSize, scrollbar.unitSize * props.minThumbSize);
    }

    getVerticalThumbHeight2(viewRef, trackRef, thumbSize, minThumbSize = 32) {
        if(!viewRef || !trackRef)    return 0;

        const {scrollHeight, clientHeight} = viewRef;
        if(scrollHeight == 0)    return 0;
        const trackHeight = this.getTrackInnerHeight(trackRef);
        const height = Math.ceil(clientHeight / scrollHeight * trackHeight);

        if(trackHeight === height) return 0;

        if(thumbSize) return thumbSize;

        return Math.max(height, minThumbSize);
    }

    //
    getScrollLeftForOffset(scrollbar, offset)  {
        return this.getScrollLeftForOffset2(offset, scrollbar.viewRef, scrollbar.horizontalTrackRef, scrollbar.unitSize * scrollbar.props.thumbSize, scrollbar.unitSize * scrollbar.props.minThumbSize);
    }

    getScrollLeftForOffset2(offset, viewRef, trackRef, thumbSize, minThumbSize = 32) {
        if(!viewRef || !trackRef)    return 0;

        const {scrollWidth, clientWidth} = viewRef;
        const trackWidth = this.getTrackInnerWidth(trackRef);
        const thumbWidth = this.getHorizontalThumbWidth2(viewRef, trackRef, thumbSize, minThumbSize);

        if(trackWidth - thumbWidth == 0)    return 0;

        return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
    }

    //
    getScrollTopForOffset(scrollbar, offset)  {
        return this.getScrollTopForOffset2(offset, scrollbar.viewRef, scrollbar.verticalTrackRef, scrollbar.unitSize * scrollbar.props.thumbSize, scrollbar.unitSize * scrollbar.props.minThumbSize);
    }

    getScrollTopForOffset2(offset, viewRef, trackRef, thumbSize, minThumbSize = 32)  {
        if(!viewRef || !trackRef)    return 0;

        const {scrollHeight, clientHeight} = viewRef;
        const trackHeight = this.getTrackInnerHeight(trackRef);
        const thumbHeight = this.getVerticalThumbHeight2(viewRef, trackRef, thumbSize, minThumbSize);

        if(trackHeight - thumbHeight == 0)  return 0;

        return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
    }

    //
    getViewParams(scrollbar, props)    {
        return {
            scrollbarSize: this.getScrollbarSize()
        };
    }

    //
    getHorizontalParams(scrollbar, props)   {
        props = props || scrollbar.props;
        return this.getHorizontalParams2(scrollbar.viewRef, scrollbar.horizontalTrackRef, scrollbar.unitSize * props.thumbSize, scrollbar.unitSize * props.minThumbSize, scrollbar.props.horizontalTrackVisiblity);
    }

    getHorizontalParams2(viewRef, trackRef, thumbSize, minThumbSize = 32, trackVisibility = CustomScrollbarTrackVisibility.default) {
        if(!viewRef || !trackRef)    {
            return {
                trackVisible: false,
                thumbVisible: false,
                thumbPos: 0,
                thumbSize: 0
            };
        }

        //
        const {clientWidth, scrollLeft, scrollWidth} = viewRef;
        const trackSize = this.getTrackInnerWidth(trackRef);
        let thumbSize_ = this.getHorizontalThumbWidth2(viewRef, trackRef, thumbSize, minThumbSize);

        let thumbPos = 0;
        if(scrollWidth - clientWidth != 0)  thumbPos = scrollLeft / (scrollWidth - clientWidth) * (trackSize - thumbSize_);

        thumbSize_ = Math.min(thumbSize_, trackSize - thumbPos);

        return {
            trackVisible: trackVisibility == CustomScrollbarTrackVisibility.always || (trackVisibility == CustomScrollbarTrackVisibility.auto && scrollWidth > clientWidth),
            thumbVisible: scrollWidth > clientWidth,
            thumbPos: thumbPos,
            thumbSize: thumbSize_
        };
    }

    //
    getVerticalParams(scrollbar, props)   {
        props = props || scrollbar.props;
        return this.getVerticalParams2(scrollbar.viewRef, scrollbar.verticalTrackRef, scrollbar.unitSize * props.thumbSize, scrollbar.unitSize * props.minThumbSize, scrollbar.props.verticalTrackVisiblity);
    }

    getVerticalParams2(viewRef, trackRef, thumbSize, minThumbSize = 32, trackVisibility = CustomScrollbarTrackVisibility.default) {
        if(!viewRef || !trackRef)    {
            return {
                trackVisible: false,
                thumbVisible: false,
                thumbPos: 0,
                thumbSize: 0
            };
        }

        //
        const {clientHeight, scrollTop, scrollHeight} = viewRef;
        const trackSize = this.getTrackInnerHeight(trackRef);
        let thumbSize_ = this.getVerticalThumbHeight2(viewRef, trackRef, thumbSize, minThumbSize);
        
        let thumbPos = 0;
        if(scrollHeight - clientHeight != 0)  thumbPos = scrollTop / (scrollHeight - clientHeight) * (trackSize - thumbSize_);

        thumbSize_ = Math.min(thumbSize_, trackSize - thumbPos);

        return {
            trackVisible: trackVisibility == CustomScrollbarTrackVisibility.always || (trackVisibility == CustomScrollbarTrackVisibility.auto && scrollHeight > clientHeight),
            thumbVisible: scrollHeight > clientHeight,
            thumbPos: thumbPos,
            thumbSize: thumbSize_
        };
    }

    //
    getClassName(scrollbar, props) {
        props = props || scrollbar.props;
        return this.getClassName2(props.className, scrollbar.horizontalParams, scrollbar.verticalParams);
    }

    getClassName2(className = '', horizontalParams, verticalParams) {
        return `custom-scrollbar ${horizontalParams.trackVisible && verticalParams.trackVisible ? 'show-track-gap' : ''} ${className}`;
    }

    //
    getViewStyle(scrollbar)    {
        return this.getViewStyle2(scrollbar.viewParams);
    }

    getViewStyle2(params)    {
        return {
            marginRight: `-${params.scrollbarSize}px`,
            marginBottom: `-${params.scrollbarSize}px`,
        }
    }

    //
    getHorizontalTrackStyle(scrollbar) {
        return this.getHorizontalTrackStyle2(scrollbar.horizontalParams, scrollbar.autoHide);
    }

    getHorizontalTrackStyle2(params, hide) {
        return {
            visibility: params.trackVisible ? 'visible' : 'hidden',
            opacity: hide ? 0 : 1
        }
    }

    //
    getVerticalTrackStyle(scrollbar) {
        return this.getVerticalTrackStyle2(scrollbar.verticalParams, scrollbar.autoHide);
    }

    getVerticalTrackStyle2(params, hide) {
        return {
            visibility: params.trackVisible ? 'visible' : 'hidden',
            opacity: hide ? 0 : 1
        }
    }

    //
    getHorizontalThumbStyle(scrollbar) {
        return this.getHorizontalThumbStyle2(scrollbar.horizontalParams);
    }

    getHorizontalThumbStyle2(params) {
        return {
            visibility: params.trackVisible && params.thumbVisible ? 'visible' : 'hidden',
            //transform: `translateX(${params.thumbPos}px)`,
            left: `${params.thumbPos}px`,       // do not use transform because this increases size by 1px in firefox (sounds strange but it is what it is)
            width: params.thumbSize,
        }
    }

    //
    getVerticalThumbStyle(scrollbar) {
        return this.getVerticalThumbStyle2(scrollbar.verticalParams);
    }

    getVerticalThumbStyle2(params) {
        return {
            visibility: params.trackVisible && params.thumbVisible ? 'visible' : 'hidden',
            //transform: `translateY(${params.thumbPos}px)`,
            top: `${params.thumbPos}px`,        // see getHorizontalThumbStyle2
            height: params.thumbSize,
        }
    }

    //
    getTrackGapStyle(scrollbar) {
        return this.getTrackGapStyle2(scrollbar.autoHide);
    }

    getTrackGapStyle2(hide)  {
        return {
            opacity: hide ? 0 : 1
        }
    }
};

export default new CustomScrollbarHelper();